import { useSelector } from "react-redux";

import { IDuplicateCheckResult } from "Model/Omikron/IDuplicateCheckResult";
import { selectDuplicateCheckResults } from "Store/Selectors/Omikron";

export function useResult(resultItemId: string): IDuplicateCheckResult {
  const resultList = useSelector(selectDuplicateCheckResults);
  return resultList.flat().find((result) => result[`@resultId`] === resultItemId);
}
